import React, { useState } from 'react';
import Axios from "axios";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { ForgotpwdAPIURL } from '../apiconstants/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from '../helpers/loadingspinner';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BeforeLoginHeader from '../commonlayouts/beforeloginheader';
import FooterLayout from '../commonlayouts/beforeloginfooter';
import Swal from 'sweetalert2';
function ForgotPassword() {

  const formSchema = Yup.object().shape({
    email: Yup.string().email().required(),
  })
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, reset, formState } = useForm(formOptions);
  const { errors } = formState
  const { isSubmitting } = formState;
  const apiUrl = ForgotpwdAPIURL.APIURL;
  const [isLoading, setIsLoading] = useState(false);
  const clientID = localStorage.getItem("clientID")


  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();

    setIsLoading(true)
    const fliterdata = { eMail: data.email };
    Axios.post(apiUrl, fliterdata)
      .then((result) => {
        setIsLoading(false)
        if (result.data.message === "Success") {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Reset password link sent to your email, please check your email for further instructions.',
          showConfirmButton: false,
          timer: 5000
        })
        
        //toast.success('Data Saving', {autoClose:5000})

      }
      else if(result.data.message ==="EmailID is not Exist") {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Please provide a valid Email ID.',
          showConfirmButton: false,
          timer: 5000
        })
        // toast.error('Issue with data format', {autoClose:5000})
      }

      else{
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Something gone wrong',
          showConfirmButton: false,
          timer: 5000
        })

      }
      }).catch(
        function (error) {
          console.log("Error" + error)
          setIsLoading(false)
        })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }


  return (
    <>
    <BeforeLoginHeader>
            {isLoading ? <center> <LoadingSpinner /> </center> :

        <div class="card shadow-sm p-5 border-0 login-card" >
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
            <h2 class="text-center mb-4 tq-wall"> No Worries!  Enter your email and we will send you a reset Link.</h2>

            <div class="mb-5 mt-3">

              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                <input
                  placeholder='Email'
                  type="email"
                  name="email"
                  {...register("email")}
                  className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.email?.message}</div>    </div>

            <div class="text-center mb-5">
            
              {/* <button disabled={isSubmitting} class="btn btn-primary login-button" style={{ width: "25%"}}> */}
                {/* {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>} */}
              <button className='btn btn-primary' style={{width:"25%",fontWeight:"bold"}}>
                Send Request
              </button>
              <Link to={`/Login?clientId=${clientID}`}> <button  class="btn btn-primary " style={{backgroundColor:"#00a7ac",border:"none",borderRadius: 15,fontWeight:"bold"}}>
    
                 Cancel
                </button>
                </Link>
            </div>

          </form>
        </div>
      }
      </BeforeLoginHeader>
      <FooterLayout/>
    </>
  )
}

export default ForgotPassword;